import React, { useEffect, useState } from 'react';
import { useTheme } from "@ohif/ui"
const Pagination = ({ onChangePage, currentPage, perPage, onChangePerPage, totalPage }) => {

  useEffect(() => {
    if (currentPage) {
      setCurrentPage(currentPage)
    }
  }, [currentPage])
  const navigateToPage = page => {
    const toPage = page < 1 ? 1 : page;
    if (toPage < 1 || toPage > totalPages) return;
    setCurrentPage(toPage)
    onChangePage(toPage);
  };

  const getPaginationRange = () => {
    const totalPageNumbers = 7; // Adjust how many buttons max (including dots)

    if (totalPages <= totalPageNumbers) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const DOTS = '...';
    const leftSiblingIndex = Math.max(page - 1, 1);
    const rightSiblingIndex = Math.min(page + 1, totalPages);

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < totalPages - 1;

    const firstPageIndex = 1;
    const lastPageIndex = totalPages;

    if (!showLeftDots && showRightDots) {
      const leftItemCount = 3;
      const leftRange = Array.from({ length: leftItemCount + 2 }, (_, i) => i + 1);
      return [...leftRange, DOTS, totalPages];
    }

    if (showLeftDots && !showRightDots) {
      const rightItemCount = 3;
      const rightRange = Array.from(
        { length: rightItemCount + 2 },
        (_, i) => totalPages - (rightItemCount + 1) + i
      );
      return [firstPageIndex, DOTS, ...rightRange];
    }

    if (showLeftDots && showRightDots) {
      return [firstPageIndex, DOTS, page - 1, page, page + 1, DOTS, lastPageIndex];
    }
  };

  const ranges = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ];
  const [selectedRange, setSelectedRange] = useState(ranges.find(r => r.value === perPage));
  const [page, setCurrentPage] = useState(1);
  const [value, setInputValue] = useState(1);
  const totalPages = Math.ceil(totalPage / perPage);

  const onSelectedRange = selectedRange => {
    setSelectedRange(selectedRange);
    onChangePerPage(selectedRange.value);
  };
  const { isDarkMode } = useTheme();
  return (
    <div className="pagination">
      <div className="pagination__result"> {page * perPage - perPage + 1} -{" "}
        {Math.min(page * perPage, totalPage)} of {totalPage} results</div>
      <nav
        aria-label="pagination navigation"
        className="MuiPagination-root MuiPagination-outlined css-1oj2twp-MuiPagination-root">
        <ul className="MuiPagination-ul css-wjh20t-MuiPagination-ul">
          <li>
            <button
              className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex={-1}
              type="button"
              onClick={() => navigateToPage(1)}

              disabled={page === 1}
              aria-label="Go to first page">
              <svg
                style={
                  isDarkMode ? { filter: 'invert(1)' } : null}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.83333 11.3332L4.5 7.99984L7.83333 4.6665M12.5 11.3332L9.16667 7.99984L12.5 4.6665"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </button>
          </li>
          <li>
            <button
              className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex={-1}
              type="button"
              disabled={page === 1}
              aria-label="Go to previous page"
              onClick={() => navigateToPage(page - 1)}
            >
              <svg
               style={
                isDarkMode ? { filter: 'invert(1)' } : null}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5 12L6.5 8L10.5 4"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </li>
          {/* {[...Array(totalPages)].map((_, index) => (
            <li key={index}>
              <button
                // className={page===index+1?"MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded  MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root Mui-selected":"MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded  MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"`}
                className={`MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root ${page === index + 1 ? "Mui-selected" : ""}`}
                tabIndex={0}
                type="button"
                aria-current="true"
                aria-label="page 1"
                onClick={() => navigateToPage(index + 1)}
              >
                {index + 1}<span
                  className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"
                ></span>
              </button>
            </li>
          ))} */}
          {getPaginationRange()?.map((item, index) => (
            <li key={index}>
              {item === '...' ? (
                <span className="MuiPaginationItem-root MuiPaginationItem-ellipsis">…</span>
              ) : (
                <button
                  className={`MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root ${page === item ? "Mui-selected" : ""}`}
                  tabIndex={0}
                  type="button"
                  onClick={() => navigateToPage(item)}
                >
                  {item}
                </button>
              )}
            </li>
          ))}
          <li>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex={page === totalPages ? -1 : 0}
              type="button"
              disabled={page === totalPages}
              onClick={() => navigateToPage(page + 1)}
              aria-label="Go to next page"
            >
              <svg
               style={
                isDarkMode ? { filter: 'invert(1)' } : null}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.5 12L10.5 8L6.5 4"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"></path></svg>
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
          <li>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabIndex={page === totalPages ? -1 : 0}
              type="button"
              onClick={() => navigateToPage(totalPages)}

              disabled={page === totalPages}
              aria-label="Go to last page"
            >
              <svg
               style={
                isDarkMode ? { filter: 'invert(1)' } : null}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.66667 11.3332L12 7.99984L8.66667 4.6665M4 11.3332L7.33333 7.99984L4 4.6665"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
        </ul>
      </nav>
      <div className="pagination__actions">
        <h6>Go to page</h6>
        <input
          type="text"
          min="1"
          max={totalPages}
          value={value}
          className="formField__input sm"
          onChange={(e) => setInputValue(Number(e.target.value))}
        />
        <button
          disabled={value === currentPage || value > totalPages}
          className="btn btn__primary"
          onClick={() => navigateToPage(Number(value))}
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default Pagination;
